import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { getValueFromOptions } from '../../../utils/dataUtil'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function CheckApprovalTable({
  schema,
  isShowConf,
  setIsShowConf = () => {},
  onSelect,
  loading,
  isViewMode,
  page = 1,
  displayLength = 10,
  defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 40, label: 40 },
  ],
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  // const [displayLength, setDisplayLength] = useState(pageNumber)
  // const [page, setPage] = useState(pageSize)

  const [selectData, setSelectData] = useState()
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    // setPage(1)
    // setDisplayLength(dataKey)

    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    // setPage(dataKey)

    onReload(dataKey, displayLength)
  }

  return (
    <>
      <Table
        wordWrap
        // minHeight={800}
        // autoHeight
        height={850}
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '20px' }}
      >
        <Column align="center" width={90} fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell dataKey="numberOfSequence" />
        </Column>
        <Column width={120} align="left">
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={120} align="left">
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>
        <Column width={300} minWidth={300} flexGrow={1} align="left">
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>
        <Column width={120} align="left">
          <HeaderCell>สำนัก</HeaderCell>
          <Cell dataKey="departmentName" />
        </Column>
        <Column width={120} align="left">
          <HeaderCell>ปีงบประมาณ</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>
        <Column width={160} align="left">
          <HeaderCell>ประเภท</HeaderCell>
          <Cell dataKey="approveTypeLabel" />
        </Column>
        <Column width={250} align="left">
          <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>
        <Column width={200} align="left">
          <HeaderCell>ตำแหน่ง</HeaderCell>
          <Cell dataKey="position" />
        </Column>
        <Column width={180} align="left">
          <HeaderCell>สิทธิ์การอนุมัติ</HeaderCell>
          <Cell dataKey="approveLevelName" />
        </Column>
        <Column width={150} align="left">
          <HeaderCell>วันที่อนุมัติ</HeaderCell>
          <Cell dataKey="dateApprove" />
        </Column>
        <Column width={150} align="left" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  {!rowData.dateApprove && (
                    <SaveButton
                      icon="send-o"
                      onClick={() => {
                        setSelectData(rowData)
                        setIsShowConf(true)
                      }}
                    >
                      ส่งอีเมล
                    </SaveButton>
                  )}
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 10}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      <ConfirmWidget
        title={''}
        show={isShowConf}
        size="sm"
        detail={<div style={{ marginTop: 10, paddingTop: -10 }}>ยืนยันการส่งอีเมล</div>}
        onCancle={() => setIsShowConf(false)}
        onConfirm={() => onSelect(selectData)}
      />
    </>
  )
}
